module.exports = __webpack_public_path__ + "img/icon15.88fbc8c6.png";